/**
 * useCajaDemoMay12Seed.ts — Bootstrap demo de caja (una sola vez, sin borrar datos).
 *
 * Inicializa claves vacías y un cierre de referencia si hace falta.
 * No resetea sesiones abiertas ni ventas guardadas entre recargas o días.
 */

import { useEffect, useRef } from "react";
import { applyCajaDemoFreshStart } from "../demo/applyCajaDemoFreshStart";

/**
 * Para forzar de nuevo:
 * `applyCajaDemoFreshStart({ force: true }); location.reload()`
 */
export function useCajaDemoMay12Seed(): void {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    applyCajaDemoFreshStart();
  }, []);
}
